
export const ACCESS_TOKEN= 'accessToken'

export const token = '7673aa70-a7f7-11eb-bcbc-0242ac130002'

export const AUTHORIZATION = 'x-auth'

export const COMPANIES = 'companies'

export const API_SERVER = 'https://apps.kpi.com/services'

// export const API_SERVER = 'http://localhost:8080/services'

export const BASE_URL = '/api/v2'

export const DEFAULT_LANGUAGE = 'en'
